<template>
  <b-container>
      <b-card>
        <FormPrivacyLgpd ref="FormPrivacyLgpd"
          :id="id"
          :request-form="requestForm"></FormPrivacyLgpd>
        <b-row class="mt-2">
          <b-col
            lg="12">
            <b-form @submit.prevent="saveHandling">
              <b-row class="m-0" >
                <b-col md="6">
                  <validation-provider
                      #default="validationContext"
                      :name="$t('status')"
                      rules="required"
                      class="flex-grow"
                      slim>
                    <b-form-group
                      :label="$t('status')"
                      label-for="status">
                      <b-form-select
                        id="status"
                        class="required-select"
                        :options="listStatus"
                        text-field="label"
                        value-field="key"
                        v-model="modelStatus">
                        <!-- This slot appears above the options from 'options' prop -->
                        <template #first>
                          <b-form-select-option :value="null" disabled>-- Selecione uma opção --</b-form-select-option>
                        </template>
                      </b-form-select>
                        <b-form-invalid-feedback :class="[{'absolute': inline}]">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    </validation-provider>
                </b-col>
              </b-row>
              <b-row class="m-0" >
                <b-col>
                  <!-- publicAccess -->
                  <b-form-group
                    :label="$t('form_handling_preview')"
                    label-for="pacess">
                    <b-form-radio-group
                      id="pacess"
                      name="pacess"
                      v-model="publicAccess">
                      <b-form-radio :value="false">{{$t('private')}}</b-form-radio>
                      <b-form-radio :value="true">{{$t('public')}}</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>

                  <b-form-group
                    :label="$t('form_handling')"
                    label-for="treatment">
                      <simple-editor v-model="textTreatment" class="mb-2"></simple-editor>
                    </b-form-group>
                </b-col>
              </b-row>
              <b-row class="m-0 pt-2" >
                <b-col>
                  <b-form-group
                    :label="$t('forwarding_description_public')"
                    label-for="forwarding_description">
                      <simple-editor v-model="forwardingDescription" class="mb-2"></simple-editor>
                    </b-form-group>
                </b-col>
              </b-row>
              <b-row class="m-0 pt-2" >
                <b-col lg="12">
                  <FormulateInput
                    type="file"
                    name="file"
                    v-model="listFiles"
                    label="Anexos"
                    help="Selecione um ou mais arquivos em PDF, Word ou imagens"
                    validation="mime:application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,image/png"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    multiple/>
                </b-col>
              </b-row>

              <b-row class="pt-2" v-if="handlingFiles.length > 0">
                <b-col md="12">
                  <media-list :medias="handlingFiles"
                              :show-delete="true"
                              :action-on-click="false"
                              @deleteMedia="deleteMedia"/>
                </b-col>
              </b-row>

              <div class="mt-1 mb-2">
                <div class="flex justify-end">
                   <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-1 mr-1 float-right"
                    :disabled="!validateForm"
                    @click="saveHandling()">
                      {{$t('save')}}
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-secondary"
                    class="mt-1 mr-1 float-right"
                    @click="$router.push('/privacy-form')">
                      {{$t('back')}}
                  </b-button>
                </div>
              </div>
            </b-form>
          </b-col>
        </b-row>
    </b-card>
  </b-container>
</template>

<script>
import {serializeFormData} from '@/util/Util.ts'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, email } from '@validations'
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import SimpleEditor from '@/components/SimpleEditor.vue'

import {
  BContainer,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadio,
  BFormRadioGroup,
  BFormTextarea,
  BFormSelect,
  BFormSelectOption,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

//Services
import PrivacyFormHandlingService from '@/services/api/PrivacyFormHandlingService'
import RequestCategoryFormService from '@/services/api/RequestCategoryFormService'
import GenericService from '@/services/api/GenericService'

import FormPrivacyLgpd from './FormPrivacyLgpd'
import MediaList from '@/components/media/MediaList.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    Datepicker,
    vSelect,
    BContainer,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
    BCard,
    BTable,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    VBTooltip,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
    //
    FormPrivacyLgpd,
    MediaList,
    SimpleEditor,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    id: null,
    requestForm : null,
    textTreatment: '',
    forwardingDescription: '',
    publicAccess: false,
    status: '',
    modelStatus: null,
    listFiles: [],
    handlingFiles: [],
    listStatus: [],
    services: {
      privacyFormHandlingService: null,
      requestCategoryFormService: null,
      genericService: null,
    },
  }),
  methods: {
    saveHandling(){
      this.confirmTreatmentPublic(this.modelStatus)
    },
    confirmTreatmentPublic(status){
      if(this.publicAccess){
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Confirmação',
          acceptText: 'Sim',
          cancelText: 'Não',
          text: this.$t('protocol_query.msg_status_public_confirm'),
          accept: () => {
            this.save(status)
          }
        })
      }else{
        this.save(status)
      }
    },
    save(varStatus) {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      //File handling
      const formData = this.handlingFormData(varStatus)

      this.services.privacyFormHandlingService.updateHandling(this.id, formData)
        .then(
          data => {
            this.$vs.loading.close()
            this.clearFields()
            this.sucessNotify()
            //Update status view
            this.requestForm.request_form_handling = data.request_form_handling;
            //Consult again
            this.getData(this.id)
            this.updateListFilesOnSave()
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    getData(id) {
      this.$vs.loading()
      this.services.privacyFormHandlingService.read(id).then(
        data => {
          this.requestForm = data;
          this.status = this.requestForm.request_form_handling.status;
          this.handlingFiles = _.get(this.requestForm, 'request_form_handling.files', [])
          this.$vs.loading.close()
        },
        error => {
          this.$vs.loading.close()
        }
      )
    },
    clearFields() {
      this.textTreatment = ''
      this.forwardingDescription = ''
      this.modelStatus = null
      this.publicAccess = false
    },
    updateListFilesOnSave(){
      this.listFiles = []
    },
    handlingFormData(varStatus){
      const formData = {
          id: this.id,
          description: this.textTreatment,
          status: varStatus,
          public_access: this.publicAccess,
          forwarding_description: this.forwardingDescription,
          files: this.listFiles
        }

        return serializeFormData(formData)
    },
    deleteMedia(media){
      this.$vs.loading()
      const handlingId = _.get(this.requestForm, 'request_form_handling.id')

      this.services.privacyFormHandlingService.deleteAttachment(this.id, handlingId, media.id).then(
        data => {
          this.notifySuccess(this.$vs, "Anexo removido!")
          //Update list handling files
          let newListfiles = _.remove(this.handlingFiles, function(element) {
            return element.id !== media.id
            })
          this.handlingFiles = newListfiles
        },
        error => {
          this.notifyError(this.$vs, "Não foi possível remover o anexo.")
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    confirmClosed() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja encerrar o atendimento?',
        accept: () => {
          this.saveClose()
        }
      })
    },
    sucessNotify() {
      this.$vs.notify({
        title: 'Successo!',
        text: 'Operação realizada com sucesso.',
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-check-circle'
      })
    },
  },
  computed: {
    validateForm() {
      return this.modelStatus !== null
    }
  },
  mounted() {
    //this.$vs.loading.close()
    if (this.id) {
      this.getData(this.id)
    }

    this.services.requestCategoryFormService.all().then(
      data => {
        this.requestCategoryList = data
      },
      error => {
        this.$vs.loading.close()
      }
    )
  },
  beforeMount() {
    //this.$vs.loading()
    const promisses = []

    this.services.requestCategoryFormService = RequestCategoryFormService.build(this.$vs)
    this.services.privacyFormHandlingService = PrivacyFormHandlingService.build(this.$vs)
    this.services.genericService = GenericService.build(this.$vs)


    promisses.push(
      this.services.genericService.getFormHandlingStatus(this.id).then(
        data => {
          this.listStatus = data
        },
        error => {
          this.$vs.loading.close()
        }
      )
    )
  }
}
</script>
